export default function HeroSection() {
  return (
    <section id="startseite" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/edited_fbf6b80e04ea6a85fbe1e11292302357_ad202824.jpg"
          alt="Picobello Hausservice Transporter"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/cd07971963afdd53018db5f4e5a97aca.png"
              alt="Picobello Hausservice Logo"
              className="h-32 w-32 mx-auto mb-6 drop-shadow-2xl"
            />
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 drop-shadow-lg">
            Wir hinterlassen alles Picobello!
          </h1>
          
          <p className="text-xl md:text-2xl text-white mb-8 drop-shadow-md">
            Ihr zuverlässiges Umzugsunternehmen in Hildesheim und Umgebung
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:015758089488" 
              className="bg-orange-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Mobil: 015758089488
            </a>
            <a 
              href="tel:051211772025" 
              className="bg-white text-orange-500 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Festnetz: 05121 1772025
            </a>
          </div>

          <div className="mt-8">
            <a 
              href="https://wa.me/4915758089488" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-16 h-16 bg-green-500 text-white rounded-full hover:bg-green-600 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line text-3xl"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl drop-shadow-lg"></i>
      </div>
    </section>
  );
}